import React from 'react';
import TextField from '@mui/material/TextField';
import CheckIcon from '@mui/icons-material/Check';
import { FormHelperTextProps, InputAdornment, Stack } from '@mui/material';

interface TextFieldWithCheckProps {
  id: string;
  name: string;
  label?: string;
  value: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  variant?: 'outlined' | 'standard';
  multiline?: boolean;
  rows?: number;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
  FormHelperTextProps?: Partial<FormHelperTextProps>;
  fullWidth?: boolean;
  sx?: object; // Agregar esta línea para aceptar la prop `sx`
  endAdornment?: React.ReactNode;
}

const TextFieldWithCheck: React.FC<TextFieldWithCheckProps> = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  variant = 'outlined',
  multiline = false,
  rows = 1,
  helperText,
  error,
  disabled,
  FormHelperTextProps,
  fullWidth = false, // Valor por defecto
  sx,
  endAdornment,
}) => {
  const renderCheckIcon = (value: string) => {
    return value ? <CheckIcon color="primary" /> : null;
  };

  const checkIcon = renderCheckIcon(value);
  const showAdornment = !!endAdornment || !!checkIcon;

  return (
    <TextField
      id={id}
      name={name}
      label={label}
      variant={variant}
      value={value || ''}
      onChange={onChange}
      onBlur={onBlur}
      InputProps={{
        endAdornment: showAdornment ? (
          <InputAdornment position="end" sx={{ mr: -0.5 }}>
            <Stack direction="row" spacing={0.5} alignItems="center">
              {endAdornment}
              {checkIcon}
            </Stack>
          </InputAdornment>
        ) : undefined,
      }}
      multiline={multiline}
      rows={rows}
      helperText={helperText}
      error={error}
      disabled={disabled}
      FormHelperTextProps={FormHelperTextProps}
      fullWidth={fullWidth} // Propagamos el valor de fullWidth
      sx={sx}
    />
  );
};

export default TextFieldWithCheck;
